import * as React from "react";
import { singleton } from "logic/singleton";
const SearchPagePreferencesContext = React.createContext(void 0);
export default singleton("contexts.SearchPagePreferences", () => SearchPagePreferencesContext);
